import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {css} from "@emotion/react";
import {Button} from "@pg-design/button";
import {centerAbsolute, flexAbsoluteCenter, flexDirection, mb, mt, zIndex} from "@pg-design/helpers-css";
import {BrandSearchIcon, LockOutlineIcon} from "@pg-design/icons";
import {Text} from "@pg-design/text";

import {dataLayer} from "../../../../../../utils/data_layer";
import {getLockerLabel} from "../../../../../../utils/get_locker_label";
import {useAppDispatch, useAppSelector} from "../../../../../../utils/hooks/store_hooks";
import {AccessStatus, useAccessStatus} from "../../../../../../utils/hooks/useAccessStatus";
import {ZIndex} from "../../../../common/app/constants/z_index";
import {chartsRoutes} from "../../../../common/app/routing/charts_routes";
import {selectAuthStatus, setAuthModal} from "../../../../features/auth/auth_slice";
import {selectUserData} from "../../../../features/users/users_slice";

interface ILockerProps {
    locked?: boolean;
    empty?: boolean;
    isMap?: boolean;
}

export const Locker = ({locked, empty, isMap}: ILockerProps) => {
    const {t, i18n} = useTranslation();
    const {isLoggedIn} = useAppSelector(selectAuthStatus);
    const dispatch = useAppDispatch();
    const userData = useAppSelector(selectUserData);
    const accessStatus = useAccessStatus();

    const handleRegister = () => {
        dataLayer({
            event: "register_modal_view",
            position: "chart"
        });
        dispatch(setAuthModal("registerUser"));
    };

    const color = isMap ? "#000" : "#fff";

    if (empty) {
        return (
            <div css={lockerWrapper}>
                <BrandSearchIcon size="13" wrapperSize="13" fill={color} />

                <Text variant="body_copy_1" color={color} css={[mb(4), mt(8)]}>
                    {t("common.chart_empty.use_autocomplete")}
                </Text>
            </div>
        );
    }

    return (
        <div css={lockerWrapper}>
            <LockOutlineIcon size="13" wrapperSize="13" fill={color} />

            <Text variant="body_copy_1" color={color} css={[mb(4), mt(8)]}>
                {getLockerLabel(i18n, userData, isLoggedIn)}
            </Text>

            {!isLoggedIn && (
                <Button variant="filled_primary" size="medium" onClick={handleRegister}>
                    {t("auth.register")}
                </Button>
            )}

            {userData && (accessStatus !== AccessStatus.FULL || locked) && (
                <Link to={chartsRoutes[i18n.language].contact}>
                    <Button variant="filled_primary" size="medium">
                        {t("common.chart_lock.contact_us")}
                    </Button>
                </Link>
            )}
        </div>
    );
};

const lockerWrapper = css`
    ${centerAbsolute("horizontal")};
    top: 40%;
    ${flexAbsoluteCenter};
    ${flexDirection("column")};
    ${zIndex(ZIndex.LOCKED_CHART)};
`;
